import clsx from "clsx";
import React, { type JSX } from "react";

import type { InputProps } from "../../../interfaces/input";
import { LoadingSkeleton } from "../../LoadingSkeleton";
import { InputError } from "../InputError";

const formatAccountNumber = (value: string) => {
  if (value.length === 1) {
    return value;
  }

  return value.replace(/(\d{1,10})(\d{1})/, "$1-$2").slice(0, 12);
};

const formatEventValue = (event: React.ChangeEvent<HTMLInputElement>) => {
  const onlyDigits = event.target.value.replace(/\D/g, "");
  const value = formatAccountNumber(onlyDigits);

  return {
    ...event,
    target: {
      ...event.target,
      value,
    },
  };
};

export const InputBankAccountNumber = ({
  field,
  label,
  className,
  errorMessage,
  onChange,
  loadingValue,
  ...attributes
}: InputProps): JSX.Element => {
  return (
    <div className={clsx("flex flex-col", className)}>
      {label && (
        <label className={clsx("mb-1 lg:mb-0.5", attributes.disabled && "opacity-50")} htmlFor={field}>
          <b>{label}</b>
        </label>
      )}

      {loadingValue ? (
        <LoadingSkeleton kind="input" />
      ) : (
        <input
          {...attributes}
          type="text"
          onChange={(e) => {
            if (onChange) {
              onChange(formatEventValue(e));
            }
          }}
          className={clsx({ "outline-feedback-error": errorMessage })}
          id={field}
          name={field}
        />
      )}

      <InputError message={errorMessage} />
    </div>
  );
};
